/** Первые N тестов открыты после отправки; остальные скрыты, чтобы нельзя было подогнать решение. */
export const VISIBLE_TEST_CASE_COUNT = 3;

export function isPublicTestCaseIndex(index: number): boolean {
  return Number.isInteger(index) && index >= 0 && index < VISIBLE_TEST_CASE_COUNT;
}

/** Индекс выбранного теста: при провале на скрытом случае остаёмся на открытом. */
export function publicTestIndexOrZero(index: number): number {
  return isPublicTestCaseIndex(index) ? index : 0;
}
